<template>
    <section>
        <ul v-if="gamesData">
            <li v-for="game in gamesData.games" v-if="!isFiltered(game) && hasAchievements(game)" v-on:click="selectGame(game)">
                <img v-bind:src="apiImage(imageUrl(game))" v-bind:alt="game.name">
                <p>{{ game.name }}</p>
            </li>
        </ul>
    </section>
</template>

<script>
    export default{
        props: {
            gamesData: {
                type: Object
            },
            api: {
                type: String
            }
        },
        methods: {
            isFiltered(game) {
                return (this.gamesData.appids_filter.indexOf(game.appid) !== -1);
            },
            hasAchievements(game) {
                return (game.has_community_visible_stats == true);
            },
            imageUrl(game) {
                return `http://media.steampowered.com/steamcommunity/public/images/apps/${game.appid}/${game.img_logo_url}.jpg`;
            },
            selectGame(game) {
                this.$emit('selectGame',game.appid);
            },
            apiImage(url) {
                let parts = url.split("/");
                return `${this.api}/img/${parts[7]}/${parts[8].replace('.jpg','')}`;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/scss/variables.scss";

    $gap: 20px;

    ul {
        list-style: none;
        margin: 0 0 0 -#{$gap};
        padding: 0;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }

    li {
        flex: 1 1 184px;
        background-color: black;
        margin-left: $gap;
        margin-bottom: $gap;
        cursor: pointer;

        @media (min-width: 410px) {
            max-width: calc(100%/2 - #{$gap});
        }
        @media (min-width: 628px) {
            max-width: calc(100%/3 - #{$gap});
        }
        @media (min-width: 816px) {
            max-width: calc(100%/4 - #{$gap});
        }
        @media (min-width: 1020px) {
            max-width: calc(100%/5 - #{$gap});
        }
        @media (min-width: 1224px) {
            max-width: calc(100%/6 - #{$gap});
        }
        @media (min-width: 1428px) {
            max-width: calc(100%/7 - #{$gap});
        }
        @media (min-width: 1632px) {
            max-width: calc(100%/8 - #{$gap});
        }
        @media (min-width: 1836px) {
            max-width: calc(100%/9 - #{$gap});
        }
    }
    img {
        display: block;
        width: 100%;
    }
    p {
        margin: 0;
        padding: 5px;
        min-height: 69px;
        color: $color-text-light;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// OwnedGames.vue?6a8e6a3d